import { Injectable } from '@angular/core';
import { ModalController } from 'ionic-angular';

@Injectable()
export class CommonFunctionsProvider {

  private colors: any;

  constructor(private modalCtrl: ModalController) {

    this.colors = {
      custom: "#e36c0a",
      customDark: "#960000",
      customDarker: "#490000",
      inactive: "#e0e0e0"
    }
    
  }

  public showEventDetails() {

    this.modalCtrl.create("EventDetails").present();

  }

  public getColors() {

    return this.colors;

  }

}



// WEBPACK FOOTER //
// ./src/providers/common-functions/common-functions.ts